import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export default function highlightKeyword(searchResult, keywordToHighlight) {
  if (!keywordToHighlight) return searchResult;
  const parts = searchResult.split(new RegExp("(".concat(keywordToHighlight, ")"), "gi"));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: parts.map((part, i) => /*#__PURE__*/_jsx("span", {
      style: part.toLowerCase() === keywordToHighlight.toLowerCase() ? {
        fontWeight: "bold"
      } : {},
      children: part
    }, i))
  });
}